import type { ReactNode } from 'react';
import { Alert, Box, Button, Paper, Typography } from '@mui/material';

export interface FinalizeRetryPanelProps {
  /** `true` → ödeme alınmış ama biletleme başarısız (uyarı tonu). */
  paymentTaken: boolean;
  running: boolean;
  onRetry: () => void;
  retryLabel?: string;
  /** Ödeme henüz alınmadıysa gösterilecek nötr mesaj. */
  pendingMessage?: ReactNode;
  title?: ReactNode;
}

/** Uçak / otobüs / araç akışlarındaki neredeyse birebir "Kesinleştir" yeniden-deneme
 *  panellerinin ortak yeri. Ödeme-alındı metni mevcut akışlarla birebir. */
export function FinalizeRetryPanel({
  paymentTaken,
  running,
  onRetry,
  retryLabel = 'Kesinleştir',
  pendingMessage = 'Rezervasyonu kesinleştirmek (PNR almak) için devam edin.',
  title,
}: FinalizeRetryPanelProps) {
  return (
    <Paper sx={{ p: 3 }}>
      {title && (
        <Typography variant="subtitle1" gutterBottom>
          {title}
        </Typography>
      )}
      {paymentTaken ? (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Ödemeniz alındı ancak biletleme (PNR) tamamlanamadı. Tekrar denemek için Kesinleştir'e basın.
        </Alert>
      ) : (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {pendingMessage}
        </Typography>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="contained" disabled={running} onClick={onRetry}>
          {running ? 'İşleniyor…' : retryLabel}
        </Button>
      </Box>
    </Paper>
  );
}
